import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { getSurfaceTypeList, getWorkroomList } from '../../../../reducers';
import cx from 'classnames';
import Card from 'components/Card';
import { ResourceCardElement } from 'components/ResourceCardElements';
import styles from 'styles/resourceCard.scss';
import S from './employableHistoryCard.scss';
import * as eventTypes from './employableEvents';
import EventPropType from 'types/event';

const EmployableEventList = ({ events, workrooms, surfaceTypes, employableType }) => {
  const eventList = events.map((event, i) => {
    const EventType = eventTypes[event.kind] ? eventTypes[event.kind] : eventTypes.note;
    return (<div key={event.id} className={S.employableEventCard}>
      <Card className={cx(styles.resourceCard, S.resourceCard)} altColor={i % 2 !== 0} >
        <div className={cx(styles.resourceCardColumn, S.phaseHistoryAside)}>
          <div className={styles.column}>
            <ResourceCardElement
              title="Task/Event"
              value={event.name}
              size="large"
              theme={S}
              wrap
            />
            <ResourceCardElement
              title={event.user_type}
              value={event.user}
              size="large"
              theme={S}
              wrap
            />
          </div>
          <div className={styles.column}>
            <ResourceCardElement
              title={event.kind === 'update_profile' ? 'Updates' : 'Note'}
              size="large"
              theme={S}
              wrap
            >
              {EventType && workrooms.length !== 0 && <EventType
                event={event}
                workrooms={workrooms}
                surfaceTypes={surfaceTypes}
                employableType={employableType}
              />}
            </ResourceCardElement>
            <ResourceCardElement
              title="Recorded On"
              value={moment(event.created_at).local().format('dddd, MM/DD/YYYY, h:mm a').toString()}
              size="large"
              theme={S}
            />
          </div>
        </div>
      </Card>
    </div>);
  });
  return <section>{eventList}</section>;
};

EmployableEventList.propTypes = {
  events: PropTypes.arrayOf(EventPropType).isRequired,
  workrooms: PropTypes.array,
  surfaceTypes: PropTypes.array,
  employableType: PropTypes.string,
};

const mapStateToProps = state => ({
  workrooms: getWorkroomList(state) || [],
  surfaceTypes: getSurfaceTypeList(state) || [],
});

export default connect(mapStateToProps)(EmployableEventList);



// WEBPACK FOOTER //
// ./client/app/shared/components/EmployableHistory/EmployableHistoryCard/employableEventList.jsx